import http from "@/http";
// 获取员工列表
export const getAccount = {
  p: "/api/user/list",
  r: data => {
    return http({
      url: "/api/user/list",
      method: "post",
      data
    });
  }
};
// 增加员
export const addAccount = {
  p: "/api/user/add",
  r: data => {
    return http({
      url: "/api/user/add",
      method: "post",
      data
    });
  }
};
// 删除
export const deleteAccount = {
  p: "/api/user/delete",
  r: data => {
    return http({
      url: "/api/user/delete",
      method: "post",
      data
    });
  }
};
// 修改
export const upDataAccount = {
  p: "/api/user/edit",
  r: data => {
    return http({
      url: "/api/user/edit",
      method: "post",
      data
    });
  }
};
// 获取全部角色
// http://base.leubao.com/api/role/all
export const getRoleList = {
  p: "/api/role/all",
  r: data => {
    return http({
      url: "/api/role/all",
      method: "get"
    });
  }
};
